import React from 'react';
import { ToggleButton, ToggleButtonGroup, alpha } from '@mui/material';

interface DateFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const DateFilter: React.FC<DateFilterProps> = ({ value, onChange }) => {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null
  ) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="date filter"
      sx={{
        mb: 3,
        display: 'flex',
        gap: 1,
        '& .MuiToggleButton-root': {
          border: '1px solid rgba(0, 217, 255, 0.2)',
          color: 'rgba(255, 255, 255, 0.7)',
          background: alpha('#1A1F2E', 0.5),
          borderRadius: '8px',
          fontSize: '0.9rem',
          fontWeight: 500,
          padding: '10px 20px',
          transition: 'all 0.2s ease',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: alpha('#00D9FF', 0.1),
            borderColor: 'rgba(0, 217, 255, 0.4)',
          },
          '&.Mui-selected': {
            background: 'linear-gradient(135deg, #00D9FF 0%, #667EEA 100%)',
            color: '#0F1419',
            border: 'none',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(0, 217, 255, 0.3)',
            '&:hover': {
              background: 'linear-gradient(135deg, #00A8CC 0%, #5568D3 100%)',
              boxShadow: '0 6px 16px rgba(0, 217, 255, 0.4)',
            },
          },
        },
      }}
    >
      <ToggleButton value="today" aria-label="today">
        Today
      </ToggleButton>
      <ToggleButton value="this_week" aria-label="this week">
        This Week
      </ToggleButton>
      <ToggleButton value="last_week" aria-label="last week">
        Last Week
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default DateFilter;
